import { api } from "@/services/api";
import {
  AttributionOptions,
  PaginatedResponse,
  User,
  UserFilters,
} from "@/types";

export class UserRepository {
  async findAll(filters: UserFilters = {}): Promise<PaginatedResponse<User>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });
    const response = await api.get(`/v1/admin/users?${params.toString()}`);

    return response.data;
  }

  async acquisitionOptions(): Promise<AttributionOptions> {
    const response = await api.get("/v1/admin/users/acquisition-options");

    return response.data;
  }
}
